export default __webpack_public_path__ + "static/media/back-arrow.ecccce44.svg";